import DashboardTemplate from '@/components/templates/DashboardTemplate';
import { Outlet } from 'react-router-dom';

const ExpenseCategoryOutlet = () => {
  return (
    <DashboardTemplate>
      <Outlet />
    </DashboardTemplate>
  );
};

export default ExpenseCategoryOutlet;
